module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0043.jpg?v=f1ca8271";